export const routes = {
  endpoints: {
    aiAgents: '/ai-agents',
    projects: '/projects',
    teams: '/teams',
    subscriptions: '/subscriptions',
    plans: '/plans',
  },
  agentsDashboardPage: '/projects/[projectId]/agents/',
};

export const pages = {
  guides: {
    getStarted: 'https://fleek.xyz/guides/eliza-guide/',
    characterfile: {
      fromScratch:
        'https://fleek.xyz/guides/eliza-guide/#manually-enter-agent-details',
      template:
        'https://fleek.xyz/guides/eliza-guide/#use-a-predefined-template',
    },
  },
  supportExternalUrl: 'https://support.fleek.xyz/hc/en-us',
};
